import { PackageType, TripType } from '../models/package.model';

export const TRIP_TYPE_LABELS: Record<TripType, string> = {
	regular: 'Reguler',
	vip: 'VIP',
	plus: 'Plus',
	private: 'Private',
};

export const PACKAGE_TYPE_LABELS: Record<PackageType, string> = {
	umrah: 'Umrah',
	hajj: 'Haji',
	halal_trip: 'Halal Trip',
};

export function tripTypeLabel(value: TripType | string | null | undefined): string {
	if (!value) return '-';
	return TRIP_TYPE_LABELS[value as TripType] ?? value;
}

export function packageTypeLabel(value: PackageType | string | null | undefined): string {
	if (!value) return '-';
	return PACKAGE_TYPE_LABELS[value as PackageType] ?? value;
}

// Badge accent per tipe trip — dipakai untuk warna kartu paket.
export function tripTypeAccent(value: TripType | string | null | undefined): string {
	switch (value) {
		case 'vip':
			return 'tw:bg-gold-100 tw:text-gold-800 tw:ring-gold-300/60';
		case 'plus':
			return 'tw:bg-brand-100 tw:text-brand-800 tw:ring-brand-300/60';
		case 'private':
			return 'tw:bg-ink-900 tw:text-white tw:ring-ink-700';
		default:
			return 'tw:bg-ink-100 tw:text-ink-700 tw:ring-ink-200';
	}
}

// Tautan WhatsApp dengan pesan ter-prefill.
export function whatsappLink(phone: string, message: string): string {
	return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
}
